import { axiosRequest } from "helpers";

export const creditHistoryService = {
	sendCreditHistory
};

const API_URL = process.env.REACT_APP_API_URL;

function sendCreditHistory(model) {
	const options = {
		method: "POST",
		data: model,
		params: {
			token: model?.token,
		},
		url: `${API_URL}/api/pre_applications/${model?.applicationId}/credit_history`,
	};
	return axiosRequest(options);
}
